// extracted by mini-css-extract-plugin
export default {"container":"ChangePassword_container__Ft3wF","form":"ChangePassword_form__pFyr6"};